import { Dropdown as AntDropdown } from 'antd'
import styled from 'styled-components'
import { space } from 'styled-system'

const Dropdown = styled(AntDropdown)`
  ${space};
`

export default Dropdown